<template>
    <component :is="template">
        <div>
            <!-- S: PC 슬라이드 배너 -->
            <main-slide v-if="!$vuetify.breakpoint.mobile" />
            <!-- E: PC 슬라이드 배너 -->

            <!-- S: Mobile 슬라이드 배너 -->
            <v-carousel v-else height="auto" hide-delimiters show-arrows-on-hover :cycle="cycle" class="main-slide" v-model="model">
                <v-carousel-item :ripple="false" v-for="(banner, index) in banners" :key="index">
                    <v-img v-if="banner.open" :src="banner.src" width="100%" contain :aspect-ratio="640 / 820" @click.stop="open(banner.open)" />
                    <router-link v-if="banner.to" :to="banner.to"><v-img :src="banner.src" width="100%" contain :aspect-ratio="640 / 820" /></router-link>
                    <v-img v-if="!banner.to && !banner.open" :src="banner.src" width="100%" contain :aspect-ratio="640 / 820" />
                </v-carousel-item>
                <!-- <div class="slide-controls grey--text text--lighten-4">
                    <button class="play" @click="stop"><v-icon color="black">{{ cycle ? mdiPause : mdiPlay }}</v-icon></button>
                    <div class="counter">
                        <div class="counter-number">{{ `${model + 1}/ ${banners.length}`}}</div>
                        <button @click="dialog = true"><v-icon color="grey lighten-4" class="ml-4px mr-n4px">mdi-plus</v-icon></button>
                    </div>
                </div>
                <v-dialog v-model="dialog" transition="dialog-bottom-transition">
                    <v-card class="close-box">
                        <v-icon @click="close" color="white">mdi-close</v-icon>
                    </v-card>
                    <v-card class="event-dialog">
                        <v-responsive class="overflow-auto">
                            <div>
                                <router-link to="/gshop/giftcards">
                                    <img class="main-dialog-img" src="/images/main/banner-pc1.jpg" alt="">
                                </router-link>
                                <router-link to="/shop/discount">
                                    <img class="main-dialog-img" src="/images/main/banner-pc2.jpg" alt="">
                                </router-link>
                                <a href="https://front.wemakeprice.com/product/1959857065?search_keyword=%25EB%2582%2598%25EB%2588%2584%25EB%25A6%25AC%2520%25EC%2583%2581%25ED%2592%2588%25EA%25B6%258C&_service=5&_no=1" target="_blank">
                                    <img class="main-dialog-img" src="/images/main/banner-pc3.jpg" alt="">
                                </a>
                                <a href="http://www.tmon.co.kr/deal/13248962078" target="_blank" >
                                    <img class="main-dialog-img" src="/images/main/banner-pc6.jpg" alt="">
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=kr.uxi.everyonesads" target="_blank">
                                    <img class="main-dialog-img" src="/images/main/banner-pc4.jpg" alt="">
                                </a>
                                <a href="#" >
                                    <img class="main-dialog-img" src="/images/main/banner-pc5.jpg" alt="">
                                </a>
                            </div>
                        </v-responsive>
                    </v-card>
                </v-dialog> -->
            </v-carousel>
            <!-- E: Mobile 슬라이드 배너 -->

            <v-container class="px-0 px-lg-12px">
                <main-profile />
                <main-button-group />
            </v-container>

            <section class="main-section best-seller">
                <v-container>
                    <div class="tit-wrap text-center">
                        <h2 class="tit tit--lg">베스트 셀러</h2>
                    </div>
                    <product-list skin="main" is-best is-recommend category-code="bestseller" limit="6" class="main-product-list" />
                </v-container>
            </section>

            <section class="main-section" style="background-color: #f9f9f9">
                <v-container>
                    <div class="tit-wrap text-center">
                        <h2 class="tit tit--lg">제휴 상품</h2>
                    </div>
                    <partners-slide />
                </v-container>
            </section>
        </div>

        <popup-layer code="main" />
    </component>
</template>
<script>
import api from "@/api";
import ProductList from "@/components/client/shop/product/product-list.vue";
import PartnersSlide from "@/components/client/main/partners-slide.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainProfile from "@/components/client/main/main-profile.vue";
import MainButtonGroup from "@/components/client/main/main-button-group.vue";
import MainSlide from "@/components/client/main/main-slide.vue";
import { mdiPlay, mdiPause, mdiPlus, mdiClose } from "@mdi/js";
export default {
    components: {
        ProductList,
        PartnersSlide,
        PopupLayer,
        MainSlide,
        MainProfile,
        MainButtonGroup,
    },
    data() {
        return {
            mdiPlay,
            mdiPause,
            mdiPlus,
            mdiClose,
            model: 0,

            slideIndex: 0,

            cycle: true,
            dialog: false,

            banners: [
                {
                    src: "/images/main/banner-m7.jpg",
                    open: "https://smartstore.naver.com/korea-books/products/9569341704?NaPm=ct%3Dlu6lheh4%7Cci%3Da28d13e3474197d3d86794830e2b632e3b2e5609%7Ctr%3Dsls%7Csn%3D627310%7Chk%3D2ec2dd599537149cc34a8018bc4d870bff09308d",
                },
                {
                    src: "/images/main/banner-m1.jpg",
                    to: "/shop/ebook",
                },
                {
                    src: "/images/main/banner-m2.jpg",
                    to: "/join",
                },
                {
                    src: "/images/main/banner-m3.jpg",
                    to: "/gshop/brand",
                },
                {
                    src: "/images/main/banner-m4.jpg",
                    to: "/shop/discount",
                },
                {
                    src: "/images/main/banner-m5.jpg",
                    to: "/shop/independent",
                },
                {
                    src: "/images/main/banner-m6.jpg",
                    open: "https://www.daehanbooks.co.kr/shop/bestseller",
                },
            ],
        };
    },
    async mounted() {
        if (!window.sessionStorage.getItem("history")) {
            await api.v1.history.post();
            window.sessionStorage.setItem("history", "history");
        }
    },
    methods: {
        open(url) {
            window.open(url);
        },
        stop() {
            if (!this.cycle) {
                this.cycle = true;
            } else {
                this.cycle = false;
            }
        },
        close() {
            this.dialog = false;
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.main}`);
        },
    },
    metaInfo: {
        link: [{ rel: "canonical", href: "https://www.daehanbooks.co.kr" }],
    },
};
</script>

<style scoped>
.best-seller {
    background: url("/images/main/section-product-background.png") no-repeat top 10px center;
}
.slide-controls {
    position: absolute;
    z-index: 5;
    bottom: 20px;
    max-width: 1230px;
    padding: 0px 12px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.counter {
    margin-left: 40px;
    background-color: grey;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
}
.main-dialog-img {
    width: 100%;
    display: block;
}
.mdiclose {
    justify-content: flex-end;
}
.close-box {
    position: fixed;
    right: 20px;
    top: 10px;
    width: auto;
    box-shadow: none !important;
    background-color: transparent;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .slide-controls {
        bottom: 120px;
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>